export default "__VITE_ASSET__D7Mj6h73__"